import { RoutesConst } from "../routeConstant";
// /users
var mainUsersURL = "".concat(RoutesConst.ROOT).concat(RoutesConst.USERS);
/** Урлы роутов для списка пользователей */
export var RoutesListUsers = {
    /** Список пользователей */
    getUsersList: function () { return mainUsersURL; },
    /** Избранные пользователи */
    getUsersFavorites: function () { return "".concat(mainUsersURL, "/favorites"); },
    getUserDetails: function (id) { return "".concat(mainUsersURL, "/").concat(id); },
    getUserEdit: function (id) { return "".concat(mainUsersURL, "/").concat(id, "/").concat(RoutesConst.EDIT); },
};
